import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';
import { Labeled, LabelPosition, ValidationProvider, ValidationSeverity } from '../shared';

@Component({
  selector: 'cf-frontend-sdk-cplace-control-skeleton',
  templateUrl: './cplace-control-skeleton.component.html',
  styleUrls: ['./styles/cplace-control-skeleton.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CplaceControlSkeletonComponent implements Labeled, ValidationProvider {
  /**
   * cplace control label.
   */
  @Input() public label = '';

  /**
   * cplace control label position.
   */
  @Input() public labelPosition: LabelPosition = 'top';

  /**
   * Used for the {@code labelFor} attribute of the label.
   */
  @Input() public labelFor = '';

  /**
   * cplace control validation message.
   */
  @Input() public validationMessage = '';

  /**
   * cplace control validation severity.
   */
  @Input() public validationSeverity: ValidationSeverity = 'info';

  /**
   * Informational alert shown with the label.
   */
  @Input() public alert = '';

  /**
   * Whether the cplace control is required or not.
   */
  @Input() public required = false;

  /**
   * Whether the cplace control should be shown in edit mode.
   */
  @Input()
  @HostBinding('class.edit-mode')
  public editMode = false;

  /**
   * Whether the cplace control should be shown in the submitting state.
   */
  @Input() public submitting = false;

  /**
   * Fade-in & Fade-out cplace control border when submit success.
   */
  @Input() public submitSuccess = false;

  /**
   * Whether the cplace control should have its submit button disabled.
   */
  @Input() public submitDisabled = true;

  /**
   * Whether the cplace control is readonly.
   */
  @Input()
  @HostBinding('class.readonly')
  public readonly = false;

  /**
   * Whether the cplace control is disabled.
   */
  @Input()
  @HostBinding('class.disabled')
  public disabled = false;

  /**
   * Whether the control should be shown in a grouped style.
   */
  @Input() public grouped = false;

  /**
   * The component ID of the control component using the skeleton.
   */
  @Input() public componentId = '';

  /**
   * Fires an event when the cancel button is clicked.
   */
  @Output() public cancelButtonClick = new EventEmitter<Event>();

  @HostBinding('class.cf-frontend-sdk-cplace-control-skeleton') public skeleton = true;

  @HostBinding('class.cf-frontend-sdk-label-position-top')
  public get labelPositionTopClass() {
    return this.labelPosition === 'top';
  }

  @HostBinding('class.cf-frontend-sdk-label-position-left')
  public get labelPositionLeftClass() {
    return this.labelPosition === 'left';
  }

  public handleCancelButtonClick(event: Event) {
    this.cancelButtonClick.emit(event);
  }
}
